import React, { useState, useEffect } from 'react';
import { ShieldAlert } from 'lucide-react';
import { isMasterUser } from '@/utils/master';
import { useUser } from '@/contexts/UserContext';

/**
 * Banner that displays when a master user is logged in
 * Shows current client being managed
 */
const MasterBanner: React.FC = () => {
  const [isMaster, setIsMaster] = useState(false);
  const { userData } = useUser();

  useEffect(() => {
    setIsMaster(isMasterUser());
  }, []);

  if (!isMaster) return null;

  const clientName = userData?.data?.data?.client?.client_name || 'Unknown Client';

  return (
    <div className="bg-amber-500 text-white px-4 py-2 flex items-center justify-center gap-2 text-sm font-medium shadow-md">
      <ShieldAlert size={18} />
      <span>
        🔑 Master Mode Active
        {clientName !== 'Unknown Client' && (
          <span className="ml-2">
            - Viewing: <span className="font-bold">{clientName}</span>
          </span>
        )}
      </span>
      <span className="ml-2 text-xs bg-amber-600 px-2 py-0.5 rounded">
        Special Features Enabled
      </span>
    </div>
  );
};

export default MasterBanner;
